import { useMemo } from 'react';

/** Trip list item shape from queryTrips. */
type TripWithEvents = { id?: string; name?: string; events?: Array<{ id?: string }> };

/**
 * Build a map from event ID to list of trips (id + name) that include that event.
 * Used by ActiveEventsList for trip link badges.
 */
export function useEventIdToTrips(tripsData: { trips?: TripWithEvents[] } | undefined): Map<string, Array<{ id: string; name: string }>> {
    return useMemo(() => {
        const map = new Map<string, Array<{ id: string; name: string }>>();
        const trips = tripsData?.trips || [];
        for (const trip of trips) {
            const tripEvents = trip.events || [];
            const tripId = trip.id;
            const tripName = trip.name;
            if (!tripId || !tripName) continue;
            for (const ev of tripEvents) {
                if (ev?.id) {
                    const list = map.get(ev.id) || [];
                    if (!list.some(t => t.id === tripId)) list.push({ id: tripId, name: tripName });
                    map.set(ev.id, list);
                }
            }
        }
        return map;
    }, [tripsData]);
}
